import React from 'react'
import { ChevronsUp, ChevronUp, Minus, ChevronDown } from 'lucide-react'
import { cn } from '@/lib/utils'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'

const priorityConfig = {
  critical: { label: 'Critical', icon: ChevronsUp, iconColor: 'text-red-600', classes: 'bg-red-50 text-red-700 border-red-200' },
  high:     { label: 'High',     icon: ChevronUp,  iconColor: 'text-orange-600', classes: 'bg-orange-50 text-orange-700 border-orange-200' },
  medium:   { label: 'Medium',   icon: Minus,       iconColor: 'text-yellow-600', classes: 'bg-yellow-50 text-yellow-700 border-yellow-200' },
  low:      { label: 'Low',      icon: ChevronDown, iconColor: 'text-blue-500', classes: 'bg-slate-100 text-slate-600 border-slate-200' },
}

const PriorityBadge = ({ priority, className, showLabel = true }) => {
  const config = priorityConfig[priority] || priorityConfig.medium
  const Icon = config.icon

  if (!showLabel) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <span className={cn('inline-flex items-center shrink-0', className)}>
            <Icon className={cn('h-4 w-4', config.iconColor)} />
          </span>
        </TooltipTrigger>
        <TooltipContent side="top" className="text-xs">
          {config.label}
        </TooltipContent>
      </Tooltip>
    )
  }

  return (
    <span className={cn(
      'inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium border',
      config.classes,
      className
    )}>
      <Icon className="h-3 w-3" />
      {config.label}
    </span>
  )
}

export default PriorityBadge
